/**
 * 문제 본문 API 응답을 요청한 시험지 순서로 되놓는다.
 * SQL의 IN 조회 결과 순서는 계약이 아니므로 응답 배열을 그대로 인쇄 순서로 쓰지 않는다.
 * 빠진 id도 함께 돌려줘, 일부 문항만 조용히 출력되는 일을 호출부가 막을 수 있게 한다.
 */
export function orderPrintProblemData(items, requestedIds) {
  const byId = new Map();
  (Array.isArray(items) ? items : []).forEach((item) => {
    const id = item?.problem_id;
    if (id != null && !byId.has(String(id))) byId.set(String(id), item);
  });

  const ordered = [];
  const missing = [];
  (Array.isArray(requestedIds) ? requestedIds : []).forEach((id) => {
    const item = byId.get(String(id));
    if (item == null) missing.push(id);
    else ordered.push(item);
  });
  return { ordered, missing };
}
